module.exports = __webpack_public_path__ + "img/Ele2.dcd882b1.jpg";